
@if (authService.loggedIn()) {
  @if (testing.layout() === 'flat') {
    <tps-flat-layout />
  } @else {
    <tps-mdi-layout />
  }
} @else {
  <tps-login />
}
